import React from 'react';
import { BaseInputLayoutProps, BaseInputProps, Option } from './index';
import useInputHelper from './inputHelper';
import MultiDropdownLayout from '../../../web/uitheme/input/MultiDropdownLayout';
import { DropdownTypes } from 'ui-builder';

export interface MultiDropdownProps extends BaseInputProps<DropdownTypes[]> {
  options?: Option[],
}

export interface MultiDropdownLayoutProps<DataType = DropdownTypes>
  extends BaseInputLayoutProps<DataType[]> {
  options?: Option<DataType>[],
}

export default function MultiDropdown(props: MultiDropdownProps) {
  const helper = useInputHelper<DropdownTypes[]>(props);

  return (
    <MultiDropdownLayout
      {...helper.getBaseInputLayoutProps()}
      hideLabel={props.hideLabel}
      options={props.options}
    />
  );
}
